// extracted by mini-css-extract-plugin
export default {"modal":"modal__3hpZk","title":"title__2GqOI","btns":"btns__1nCix","btn":"btn__3ndUU"};